export const formatCurrency = (value: number) => {
  return value.toLocaleString('ru-RU', {});
};
